import type { resources } from '../locales/resources';
import { resolveContactSlug } from './contactSlug';
import { getSlug } from './localeSlug';

type Locale = keyof typeof resources;

/** Adresse de la même page dans une autre langue (sous-ensemble d'une `localization` du CMS). */
export type SwitchLocalization = {
  locale: string;
  slug?: string | null;
};

/**
 * Nom de page (sans langue ni slash final) vers lequel mène le sélecteur de langue.
 *
 * - `localizations` fourni : on prend le nom de la page dans la langue cible ; si cette langue n'a
 *   pas de version de la page, on renvoie `''` (l'accueil de la langue) plutôt qu'une 404.
 * - `localizations` absent (vue sans données de traduction, ex. la page contact) : on garde le nom
 *   courant, traduit pour la page contact.
 * - Changer vers la langue déjà affichée ne déplace pas l'utilisateur.
 */
export function resolveSwitchSlug({
  currentSlug,
  currentLocale,
  targetLocale,
  localizations,
}: {
  currentSlug: string;
  currentLocale: Locale;
  targetLocale: Locale;
  localizations?: SwitchLocalization[];
}): string {
  if (targetLocale === currentLocale) return currentSlug;

  if (localizations) {
    const target = localizations.find((localization) => localization.locale === targetLocale);
    return target?.slug ? getSlug(target.slug) : '';
  }

  return resolveContactSlug(currentSlug, targetLocale);
}
